module.exports = __webpack_public_path__ + "img/9788949123264.1ebc6ce6.jpg";